module.exports = __webpack_public_path__ + "static/media/planilha.549edeba.xlsx";